import getBrandGeneric from './getBrandGeneric';
import getModelsByFullTextSearch from './getModelsByFullTextSearch';
import getModelTypeGeneric from './getModelTypeGeneric';
import getModelTypeUniverse from './getModelTypeUniverse';

export const CatalogService = {
  getModelsByFullTextSearch,
  getModelTypeUniverse,
  getModelTypeGeneric,
  getBrandGeneric,
};
